import { useLocation } from 'react-router-dom';
import { isExamsPublicPath } from '../../../utils/examsGate';

/**
 * The public exam report pages (#/r/<token>, #/sr/<token>) stand on their
 * own: no MainSidebar even for a signed-in viewer. Follows the router
 * location, so the sidebar comes back as soon as the viewer navigates
 * anywhere else. Copy of TeacherLoop/HideOnTeacherCheckRoute.jsx; imports
 * only the dependency-free flag module.
 */
export default function HideOnExamsPublicRoute({ children }) {
  const location = useLocation();
  return isExamsPublicPath(location.pathname) ? null : children;
}
